
<template>
  <div class="container py-4">
    <div v-if="mode === 'list'">
    <div class="d-flex justify-content-between align-items-center mb-4">
  <h4 class="font-weight-bold">Liste des Tests</h4>
  <div>


    <b-button variant="primary" size="sm" @click="startCreate">
      + Nouveau test
    </b-button>
  </div>
</div>

      <b-input-group class="mb-3">
        <b-form-input v-model="search" placeholder="Rechercher un test..." />
      </b-input-group>

      <table class="table table-bordered table-sm">
        <thead class="thead-light">
          <tr>
            <th>Nom</th>
            <th>Créé le</th>
            <th>Nombre d'items</th>
            <th>Nombre de questions</th>
            <th style="text-align: right;">Opérations</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="test in filteredTests"
  :key="test.id"
            @click="viewTestDetails(test)"
            style="cursor: pointer;"
          >
            <td>{{ test.name }}</td>
            <td>{{ formatDate(test.createdAt) }}</td>
            <td>{{ totalItems(test) }}</td>
            <td>{{ totalQuestions(test) }}</td>
            <td style="white-space:nowrap;">
              <span style="display: inline-flex; align-items: center; gap: 1rem;">
                <a href="#" @click.stop="viewTestDetails(test)">
                  <font-awesome-icon style="color: #6c757d; cursor: pointer; margin-right: 1rem;" icon="eye" />
                </a>
                <a href="#" @click.stop="editTest(test)">
                  <font-awesome-icon style="color: #007bff; cursor: pointer; margin-right: 1rem;" icon="wrench" />
                </a>
                <a href="#" @click.stop="deleteTest(test.id)">
                  <font-awesome-icon style="color: RGB(235, 76, 52); cursor: pointer;" icon="times-circle" />
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    
    </div>

    <test-details
      v-else-if="mode === 'view'"
      :test="selectedTest"
      @close="mode = 'list'"
    />

    <div v-else-if="mode === 'create'">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <b-button variant="outline-secondary" size="sm" @click="cancelCreate">⬅️ Retour à la liste</b-button>
        <h2 class="font-weight-bold mb-0">{{ editingTestId ? 'Modifier le test' : ' Création d’un test' }}</h2>
        <div style="width: 40px;"></div>
      </div>

<b-form @submit.prevent="handleSubmit">
        <div v-if="step === 1">
          <b-card class="mb-4 p-3 shadow-sm">
            <b-form-group label="Nom du test *">
              <div v-if="errors.name" class="text-danger mb-1">{{ errors.name }}</div>
              <b-form-input v-model="newTest.name" />
            </b-form-group>

            <b-form-group label="Choix *">
              <div v-if="errors.scoresNames" class="text-danger mb-1">{{ errors.scoresNames }}</div>
              <div v-for="(score, index) in newTest.scoresNames" :key="index" class="input-group mb-2">
                <b-form-input v-model="newTest.scoresNames[index]" />
                <div class="input-group-append">
                  <b-button variant="danger" size="sm" @click="removeScore(index)">✖</b-button>
                </div>
              </div>
              <b-button size="sm" variant="success" @click="addScore">+ Ajouter un choix</b-button>
            </b-form-group>

            <b-form-group label="Description">
              <b-form-textarea v-model="newTest.description" rows="2" />
            </b-form-group>
<b-form-group label="Ordre de questions aléatoire ? *">
  <b-form-radio-group
    v-model="newTest.aleatoire"
    :options="[
      { text: 'Oui', value: true },
      { text: 'Non', value: false }
    ]"
    name="aleatoire-radio"
  />
</b-form-group>


          

            <b-button variant="primary" class="mt-3" @click="goToStep2">Suivant ➡️</b-button>
          </b-card>
        </div>


  
          <div v-else-if="step === 2">
            <b-card class="mb-4 p-3 shadow-sm">
              <b-form-group label="Nombre d'items à générer">
                <b-form-input type="number" v-model.number="itemCount" min="1" />
              </b-form-group>
              <b-button variant="success" @click="generateItems">Générer les items</b-button>
            </b-card>

            <div v-for="(item, idx) in newTest.items" :key="item._localId" class="border rounded p-3 mb-4 shadow-sm bg-white">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="item-title">Item : {{ item.name || `Item ${idx + 1}` }}</div>
                <b-button variant="danger" size="sm" @click="removeItem(idx)">Supprimer l'item</b-button>
              </div>

              <b-form-group label="Nom de l'item">
                <div v-if="errorsStep2[`item-${idx}-name`]" class="text-danger small mb-1">
                  {{ errorsStep2[`item-${idx}-name`] }}
                </div>
                <b-form-input v-model="item.name" />
              </b-form-group>

              <b-form-group :label="'Description de litem ' + (item.name || ` ${idx + 1}`)">
                <b-form-textarea v-model="item.description" rows="2" />
              </b-form-group>

              <b-form-group label="Score max de l'item">
                <div v-if="errorsStep2[`item-${idx}-score`]" class="text-danger small mb-1">
                  {{ errorsStep2[`item-${idx}-score`] }}
                </div>
                <b-form-input type="number" min="0" v-model.number="item.scoreMax" />
              </b-form-group>

              <b-form-group label="Nombre de questions">
                <b-form-input type="number" v-model.number="item.questionCount" min="1" @change="generateQuestionsForItemByIndex(idx)" />
              </b-form-group>
              <b-button size="sm" variant="success" @click="generateQuestionsForItemByIndex(idx)">Générer les questions</b-button>

              <div v-for="(question, qIdx) in item.questions" :key="qIdx" class="mb-3 border rounded p-3 bg-light">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="mb-0">Question {{ qIdx + 1 }}</h6>
                  <b-button variant="danger" size="sm" @click="removeQuestionFromItem(idx, qIdx)">Supprimer la question</b-button>
                </div>

                <b-form-group :label="'Contenu de la question ' + (qIdx + 1)">
                  <div v-if="errorsStep2[`question-${idx}-${qIdx}-content`]" class="text-danger small mb-1">
                    {{ errorsStep2[`question-${idx}-${qIdx}-content`] }}
                  </div>
                  <b-form-textarea v-model="question.content" rows="2" />
                </b-form-group>

                <b-form-group v-if="question.scoresValues && question.scoresValues.length" label="Valeurs des choix">
                  <div v-if="errorsStep2[`question-${idx}-${qIdx}-scores`]" class="text-danger small mb-1">
                    {{ errorsStep2[`question-${idx}-${qIdx}-scores`] }}
                  </div>
                  <div v-for="(val, sIdx) in question.scoresValues" :key="sIdx" class="input-group mb-2">
                    <b-form-input v-model="question.scoresValues[sIdx]" :placeholder="newTest.scoresNames[sIdx]" />
                  </div>
                </b-form-group>

                <b-form-group v-if="question.choices && question.choices.length" label="Choix de réponses">
                  <div v-for="(choice, cIdx) in question.choices" :key="cIdx" class="input-group mb-2">
                    <b-form-input v-model="question.choices[cIdx]" placeholder="Choix" />
                    <b-button size="sm" variant="danger" @click="question.choices.splice(cIdx, 1)">Supprimer</b-button>
                  </div>
                  <b-button size="sm" variant="success" @click="question.choices.push('')">+ Ajouter un choix</b-button>
                </b-form-group>

                <div v-if="(!question.scoresValues || !question.scoresValues.length) && (!question.choices || !question.choices.length)" class="text-muted small">
                  Réponse texte libre
                </div>
              </div>

              <b-button size="sm" variant="primary" class="mt-2" v-if="item.questions && item.questions.length" @click="addQuestionToItem(idx)">
                ➕ Ajouter une question
              </b-button>
              <b-button size="sm" variant="secondary" class="mt-2" @click="addItem">+ Ajouter un item </b-button>

            </div>

            <div class="d-flex justify-content-between mt-4">
              <b-button variant="secondary" @click="step = 1">⬅️ Précédent</b-button>
              <b-button variant="primary" @click="goToStep3">➡️ Etape suivante : Groupes</b-button>
            </div>
          </div>

          <div v-else-if="step === 3">
            <b-card class="mb-3 p-3 shadow-sm">
              <b-form-group label="Nombre de groupes à générer">
                <b-form-input type="number" v-model.number="groupCount" min="1" />
              </b-form-group>
              <b-button variant="success" @click="generateGroupShells">Générer les groupes</b-button>
            </b-card>

            <div v-if="!newTest.items.length" class="text-warning mb-3">
              Aucun item créé — retourne à l'étape Items pour créer des items d'abord.
            </div>

            <div v-for="(group, gIdx) in newTest.itemGroups" :key="gIdx" class="border rounded p-3 mb-4 shadow-sm bg-light">
              <b-form-group label="Nom du groupe">
                <b-form-input v-model="group.groupName" placeholder="Nom du groupe" />
                <div v-if="errorsStep2[`group-${gIdx}-name`]" class="text-danger small mt-1">{{ errorsStep2[`group-${gIdx}-name`] }}</div>
              </b-form-group>

              <b-form-group label="Sélectionner les items à inclure (un item peut être sélectionné pour plusieurs groupes)">
                <div v-for="(item, idx) in newTest.items" :key="item._localId" class="mb-1 d-flex align-items-center">
                  <b-form-checkbox v-model="group.selectedItemIds" :value="item._localId">
                    {{ item.name || `Item ${idx + 1}` }}
                  </b-form-checkbox>
                </div>
                <div v-if="errorsStep2[`group-${gIdx}-items`]" class="text-danger small mt-1">{{ errorsStep2[`group-${gIdx}-items`] }}</div>
              </b-form-group>

              <div class="d-flex justify-content-between">
                <div>Items sélectionnés: {{ getGroupItemNames(group).join(', ') || '—' }}</div>
                <b-button variant="danger" size="sm" @click="removeItemGroup(gIdx)">Supprimer le groupe</b-button>
              </div>
            </div>
              <b-button variant="secondary" class="mt-2" @click="addGroupShell">+ Ajouter un groupe</b-button>

            <div class="d-flex justify-content-between mt-4">
              <b-button variant="secondary" @click="step = 2">⬅️ Précédent</b-button>
              <b-button variant="success" type="submit">{{ editingTestId ? '💾 Enregistrer' : '✅ Enregistrer le test' }}</b-button>
            </div>
          </div>
        </b-form>
    </div>
  </div>
    
</template>

<script>
import TestDetails from './TestDetails.vue';
let localIdCounter = 1;
export default {
  components: { TestDetails },
  data() {
    return {
      mode: 'list',
      step: 1,
      tests: [],
      editingTestId: null,
      selectedTest: null,
      newTest: {
        name: '',
        description: '',
        scoresNames: [''],
        items: [],
        itemGroups: [],
        aleatoire: false
      },
      errors: {},
      errorsStep2: {},
      itemCount: 1,
      groupCount: 1,
    };
  },
  watch: {
    'newTest.scoresNames': {
      handler() {
        this.syncScoresValues();
      },
      deep: true,
    },
  },
   computed: {
    filteredTests() {
      if (!this.search) return this.tests;
      const s = this.search.toLowerCase();
      return this.tests.filter(t =>
        (t.name || '').toLowerCase().includes(s) ||
        (t.description || '').toLowerCase().includes(s)
      );
    }
  },
  methods: {







    async fetchTests() {
      const res = await fetch('/api/tests');
      this.tests = await res.json();
    },
    startCreate() {
      this.cancelCreate();
      this.mode = 'create';
      this.step = 1;
    },
    goToStep2() {
      this.errors = {};
      if (!this.newTest.name || !this.newTest.name.trim()) this.errors.name = 'Le nom est requis';
      if (this.newTest.scoresNames.length === 0 || this.newTest.scoresNames.some(s => !s.trim()))
        this.errors.scoresNames = 'Tous les noms de scores doivent être remplis';
      if (Object.keys(this.errors).length === 0) {
        this.step = 2;
      }
    },
    goToStep3() {
      this.errorsStep2 = {};
      if (!this.newTest.items.length) {
        this.errorsStep2.general = 'Créez au moins un item avant de créer des groupes';
        return;
      }
      let valid = true;
      this.newTest.items.forEach((item, idx) => {
        if (!item.name || !item.name.trim()) {
          this.errorsStep2[`item-${idx}-name`] = 'Nom de l\'item requis';
          valid = false;
        }
        if (item.scoreMax === '' || item.scoreMax === null || isNaN(item.scoreMax)) {
          this.errorsStep2[`item-${idx}-score`] = 'Score max doit être un nombre';
          valid = false;
        }
        item.questions.forEach((q, qIdx) => {
          if (!q.content || !q.content.trim()) {
            this.errorsStep2[`question-${idx}-${qIdx}-content`] = 'Contenu de la question requis';
            valid = false;
          }
          if (q.scoresValues && q.scoresValues.some(v => v === '' || isNaN(v))) {
            this.errorsStep2[`question-${idx}-${qIdx}-scores`] = 'Toutes les valeurs de scores doivent être des nombres';
            valid = false;
          }
        });
      });
      if (!valid) return;
      if (!this.newTest.itemGroups.length) {
        this.generateGroupShells();
      }
      this.step = 3;
    },
    generateItems() {
      const newItems = [];
      for (let i = 0; i < this.itemCount; i++) {
        newItems.push(this._createEmptyItem(`Item ${this.newTest.items.length + i + 1}`));
      }
      this.newTest.items = this.newTest.items.concat(newItems);
      this.itemCount = 1;
    },
    addItem() {
      this.newTest.items.push(this._createEmptyItem(`Item ${this.newTest.items.length + 1}`));
    },
    removeItem(idx) {
      const id = this.newTest.items[idx]._localId;
      this.newTest.items.splice(idx, 1);
      this.newTest.itemGroups.forEach(g => {
        g.selectedItemIds = g.selectedItemIds.filter(iid => iid !== id);
      });
    },
    _createEmptyItem(defaultName = '') {
      const id = `local-${localIdCounter++}`;
      return {
        _localId: id,
        name: defaultName,
        description: '',
        scoreMax: 0,
        questionCount: 1,
        questions: [
          {
            content: '',
            scoresValues: Array(this.newTest.scoresNames.length).fill(''),
            choices: [],
          },
        ],
      };
    },
    generateQuestionsForItemByIndex(itemIdx) {
      const item = this.newTest.items[itemIdx];
      const newQs = [];
      for (let i = 0; i < (item.questionCount || 0); i++) {
        const existing = item.questions[i] || {};
        newQs.push({
          content: existing.content || '',
          scoresValues: existing.scoresValues || Array(this.newTest.scoresNames.length).fill(''),
          choices: existing.choices || [],
        });
      }
      item.questions = newQs;
    },
    addQuestionToItem(itemIdx) {
      const item = this.newTest.items[itemIdx];
      item.questions.push({
        content: '',
        scoresValues: Array(this.newTest.scoresNames.length).fill(''),
        choices: [],
      });
    },
    removeQuestionFromItem(itemIdx, qIdx) {
      this.newTest.items[itemIdx].questions.splice(qIdx, 1);
    },
    generateGroupShells() {
      const shells = [];
      for (let g = 0; g < this.groupCount; g++) {
        shells.push({
          groupName: `Groupe ${this.newTest.itemGroups.length + g + 1}`,
          selectedItemIds: [],
        });
      }
      this.newTest.itemGroups = this.newTest.itemGroups.concat(shells);
      this.groupCount = 1;
    },
    addGroupShell() {
      this.newTest.itemGroups.push({
        groupName: `Groupe ${this.newTest.itemGroups.length + 1}`,
        selectedItemIds: [],
      });
    },
    removeItemGroup(idx) {
      this.newTest.itemGroups.splice(idx, 1);
    },
    getGroupItemNames(group) {
      return (group.selectedItemIds || []).map(id => {
        const it = this.newTest.items.find(i => i._localId === id);
        return it ? (it.name || '(sans nom)') : '(supprimé)';
      });
    },
    addScore() {
      this.newTest.scoresNames.push('');
    },
    removeScore(index) {
      this.newTest.scoresNames.splice(index, 1);
    },
    syncScoresValues() {
      const scoreCount = this.newTest.scoresNames.length;
      this.newTest.items.forEach(item => {
        item.questions.forEach(question => {
          while (question.scoresValues.length < scoreCount) question.scoresValues.push('');
          if (question.scoresValues.length > scoreCount) question.scoresValues.splice(scoreCount);
        });
      });
    },
    async handleSubmit() {
      this.errorsStep2 = {};
      let valid = true;
      if (!this.newTest.itemGroups.length) {
        this.errorsStep2.general = 'Ajoutez au moins un groupe.';
        valid = false;
      } else {
        this.newTest.itemGroups.forEach((group, gIdx) => {
          if (!group.groupName || !group.groupName.trim()) {
            this.errorsStep2[`group-${gIdx}-name`] = 'Le nom du groupe est requis';
            valid = false;
          }
          if (!group.selectedItemIds || !group.selectedItemIds.length) {
            this.errorsStep2[`group-${gIdx}-items`] = 'Sélectionner au moins un item pour ce groupe';
            valid = false;
          }
        });
      }
      this.newTest.items.forEach((item, iIdx) => {
        if (!item.name || !item.name.trim()) {
          this.errorsStep2[`item-${iIdx}-name`] = 'Le nom de l’item est requis';
          valid = false;
        }
        if (item.scoreMax === '' || item.scoreMax === null || isNaN(item.scoreMax)) {
          this.errorsStep2[`item-${iIdx}-score`] = 'Le score max doit être un nombre';
          valid = false;
        }
        item.questions.forEach((q, qIdx) => {
          if (!q.content || !q.content.trim()) {
            this.errorsStep2[`question-${iIdx}-${qIdx}-content`] = 'Contenu de la question requis';
            valid = false;
          }
          if (q.scoresValues && q.scoresValues.some(v => v === '' || isNaN(v))) {
            this.errorsStep2[`question-${iIdx}-${qIdx}-scores`] = 'Toutes les valeurs de scores doivent être des nombres';
            valid = false;
          }
        });
      });
      if (!valid) {
        this.step = 3;
        return;
      }
      const payload = JSON.parse(JSON.stringify(this.newTest));
      const method = this.editingTestId ? 'PUT' : 'POST';
      const url = this.editingTestId ? `/api/tests/${this.editingTestId}` : '/api/tests';
      try {
        const res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('Erreur réseau');
        this.cancelCreate();
        this.fetchTests();
      } catch (e) {
        alert('Erreur lors de l\'envoi du test : ' + e.message);
      }
    },
    cancelCreate() {
      this.mode = 'list';
      this.step = 1;
      this.editingTestId = null;
      this.selectedTest = null;
      this.newTest = {
        name: '',
        description: '',
        scoresNames: [''],
        items: [],
        itemGroups: [],
      };
      this.errors = {};
      this.errorsStep2 = {};
      this.itemCount = 1;
      this.groupCount = 1;
    },
    editTest(test) {
      const copy = JSON.parse(JSON.stringify(test));
      copy.items = (copy.items || []).map((it, i) => {
        return {
          _localId: it._localId || `local-${localIdCounter++}`,
          name: it.name || '',
          description: it.description || '',
          scoreMax: it.scoreMax || 0,
          questionCount: it.questions ? it.questions.length : 1,
          questions: (it.questions || []).map(q => ({
            content: q.content || '',
            scoresValues: q.scoresValues ? q.scoresValues.slice() : Array(copy.scoresNames.length).fill(''),
            choices: q.choices ? q.choices.slice() : [],
          })),
        };
      });
      copy.itemGroups = (copy.itemGroups || []).map(g => ({
        groupName: g.groupName || '',
        selectedItemIds: g.selectedItemIds ? g.selectedItemIds.slice() : [],
      }));
      this.newTest = copy;
      this.syncScoresValues();
      this.editingTestId = test.id || null;
      this.mode = 'create';
      this.step = 1;
    },
    deleteTest(id) {
      if (!confirm('Supprimer ce test ?')) return;
      fetch(`/api/tests/${id}`, { method: 'DELETE' }).then(() => this.fetchTests());
    },
    viewTestDetails(test) {
      this.selectedTest = test;
      this.mode = 'view';
    },
    takeTest(testId) {
      this.$router.push(`/normatif-questionnaire/${testId}`);
    },
    viewAnswers(testId) {
      this.$router.push(`/normatif-answers/${testId}`);
    },
    totalItems(test) {
  return (test.items || []).length;
},
totalQuestions(test) {
  return (test.items || []).reduce((sum, item) => {
    return sum + (item.questions ? item.questions.length : 0);
  }, 0);
},
formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
},




  },
  mounted() {
    this.fetchTests();
  },
};
</script>

<style scoped>
.item-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #2c3e50;
  background-color: #f8f9fa;
  padding: 6px 12px;
  border-left: 4px solid #007bff;
  border-radius: 4px;
  margin-bottom: 1rem;
}
.group-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
}
.btn-add-item {
  background-color: #007bff;
  color: white;
}
.btn-add-group {
  background-color: #28a745;
  color: white;
}
</style>




